module.exports = __webpack_public_path__ + "static/media/Books.cb13f0ae.png";